var map = {
	"./060930.svg": [
		7710,
		710
	],
	"./060930_arabic.svg": [
		3175,
		175
	],
	"./0C134F.svg": [
		2199,
		199
	],
	"./0C134F_arabic.svg": [
		5135,
		135
	],
	"./159895.svg": [
		4298,
		298
	],
	"./159895_arabic.svg": [
		3082,
		340
	],
	"./206888.svg": [
		3431,
		431
	],
	"./206888_arabic.svg": [
		2202,
		202
	],
	"./3c486b.svg": [
		9255,
		255
	],
	"./3c486b_arabic.svg": [
		4827,
		827
	],
	"./4F200D.svg": [
		1832,
		832
	],
	"./4F200D_arabic.svg": [
		5991,
		991
	],
	"./4f4557.svg": [
		7335,
		335
	],
	"./4f4557_arabic.svg": [
		1911,
		911
	],
	"./678983.svg": [
		833,
		833
	],
	"./678983_arabic.svg": [
		7588,
		588
	],
	"./7c3e66.svg": [
		4858,
		858
	],
	"./7c3e66_arabic.svg": [
		5486,
		715
	],
	"./903749.svg": [
		200,
		200
	],
	"./903749_arabic.svg": [
		3847,
		847
	],
	"./ACBDC5.svg": [
		2486,
		486
	],
	"./ACBDC5_arabic.svg": [
		7559,
		559
	],
	"./C996CC.svg": [
		414,
		414
	],
	"./C996CC_arabic.svg": [
		9821,
		821
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1851;
module.exports = webpackAsyncContext;